import React from 'react';
import classNames from 'classnames';
import Icon from '~/app/common/Icon';
import classes from './style.module.scss';
import useTranslation from '~/app/hooks/useTranslation';

export interface MarkAllReadButtonProps {
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
    inline?: boolean;
}

export type MarkAllReadButtonComponent = React.FC<MarkAllReadButtonProps>;

const MarkAllReadButton: MarkAllReadButtonComponent = ({
    onClick,
    disabled = false,
    inline = false
}) => {
    const { t } = useTranslation("notifications");
    const buttonElement = (
        <button
            type="button"
            className={classNames(classes.markAllBtn, { [classes.inlineBtn]: inline })}
            onClick={onClick}
            disabled={disabled}
        >
            <Icon className={classes.markAllIcon} name={'done_all'} size={'18'} />
            <span className={classes.markAllText}>{t("markAllAsRead")}</span>
        </button>
    );

    if (inline) {
        return buttonElement;
    }

    return (
        <div className={classes.markAllWrapper}>
            {buttonElement}
        </div>
    );
};

export { MarkAllReadButton, MarkAllReadButton as MarkAllUnreadButton };
export default MarkAllReadButton;
